// authapi.ts
import { ethers } from "ethers";

export const USDC_ADDRESS = "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913";

export async function getBalance(walletAddress: string): Promise<string> {
  if (!ethers.isAddress(walletAddress)) {
    throw new Error("Invalid wallet address");
  }

  try {
    const provider = new ethers.JsonRpcProvider("https://mainnet.base.org");
    const ERC20_ABI = ["function balanceOf(address) view returns (uint256)"];
    const contract = new ethers.Contract(USDC_ADDRESS, ERC20_ABI, provider);
    const balance = await contract.balanceOf(walletAddress);
    return ethers.formatUnits(balance, 6);
  } catch (err: any) {
    console.error("Error fetching USDC balance:", err.message);
    throw new Error("Failed to fetch wallet balance: " + err.message);
  }
}

export async function getRecentTransactions(walletAddress: string): Promise<
  {
    id: string;
    type: "sent" | "received";
    amount: number;
    from: string;
    to: string;
    date: string;
    hash: string;
  }[]
> {
  if (!ethers.isAddress(walletAddress)) {
    throw new Error("Invalid wallet address");
  }
  console.log("Fetching transactions for wallet:", walletAddress);

  try {
    // Use Etherscan V2 Multichain API with Base mainnet chain ID (8453)Q
    const apiKey = "R7RF2QXY78S7ZWIKIISNXGDMHYY4HDKG6F"; // Your Etherscan API key
    const url = `https://api.etherscan.io/v2/api?chainid=8453&module=account&action=tokentx&contractaddress=${USDC_ADDRESS}&address=${walletAddress}&sort=desc&apikey=${apiKey}&page=1&offset=10`;

    const response = await fetch(url);
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Etherscan V2 API response error:", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });
      throw new Error(
        `Failed to fetch transactions from Etherscan V2: HTTP ${response.status} - ${response.statusText}`
      );
    }

    const data = await response.json();
    console.log("Etherscan V2 API response:", data);

    if (data.status !== "1") {
      console.error("Etherscan V2 API error details:", {
        status: data.status,
        message: data.message,
        result: data.result,
      });
      throw new Error(
        data.result || data.message || "Error fetching transactions"
      );
    }

    if (!Array.isArray(data.result)) {
      console.warn(
        "No transactions found or invalid response format:",
        data.result
      );
      return [];
    }

    const transactions = data.result.map((tx: any, index: number) => {
      const isReceived = tx.to.toLowerCase() === walletAddress.toLowerCase();
      return {
        id: `${tx.hash}-${index}`,
        type: isReceived ? "received" : "sent",
        amount: parseFloat(
          ethers.formatUnits(tx.value, parseInt(tx.tokenDecimal))
        ),
        from: tx.from,
        to: tx.to,
        date: new Date(parseInt(tx.timeStamp) * 1000).toLocaleString(),
        hash: tx.hash,
      };
    });

    return transactions;
  } catch (err: any) {
    console.error("Error fetching transactions:", err.message, err.stack);
    throw new Error("Failed to fetch transactions: " + err.message);
  }
}
